// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_3NMCg","button":"_1JB90","content":"SNjDh","footerBox":"_2DzPg","wrapper":"_3WBF_","return":"_2qPDK","headerBlock":"_1_D77"};